import styled from 'styled-components'
import { CityCardUnstyled } from './unstyled'

export const CityCard = styled(CityCardUnstyled)`
  height: 105px;
  border-radius: 4px;
  border: 1px solid ${props => props.theme.colors.iron};
  background-color: ${props => props.theme.colors.white};
  position: relative;
  & > div:first-child {
    height: 100%;
    width: 100%;
    padding: 20px;
    cursor: pointer;

    .title-status {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;

      label {
        border-radius: 10px;
        width: 75px;
        height: 20px;
        background-color: ${props => props.theme.colors.seeGreen};
        font-size: ${props => props.theme.fontSizes.city.card.label};
        color: ${props => props.theme.colors.white};
        font-family: ${props => props.theme.fontSizes.robotoBold};
        text-align: center;
        line-height: 20px;
        text-transform: uppercase;
      }
    }
  }

  .actions {
    position: absolute;
    display: flex;
    justify-content: flex-start;
    left: 20px;
    bottom: 20px;

    a {
      margin-right: 20px;
    }
  }

  .as-list & {
    height: auto;
    display: flex;
    flex-direction: row;
    align-items: center;

    .actions {
      position: static;
    }

    > div:first-child {
      padding: 8px 10px;

      .title-status {
        margin: 5px 0 0;
      }
    }
  }
`
